import React from "react";
import { useGlobalErrorHandler } from "@/hooks/useGlobalErrorHandler";

export function GlobalErrorProvider({ children }: { children: React.ReactNode }) {
  useGlobalErrorHandler();
  return <>{children}</>;
}
